import { Radio as AntdRadio } from "antd";
import { CMP_PREFIX } from "@/base/constant";
import { cx } from "antd-style";
import type { GetProps } from "antd";

export type RadioProps = Partial<GetProps<typeof AntdRadio>>;
export type RadioGroupProps = Partial<GetProps<typeof AntdRadio.Group>>;

export const radioPrefixCls = `${CMP_PREFIX}-radio`;

export const Radio = ({ ...props }: RadioProps) => {
  return <AntdRadio {...props} />;
};

export const RadioGroup = ({
  optionType,
  className,
  ...props
}: RadioGroupProps) => {
  return (
    <AntdRadio.Group
      optionType={optionType}
      className={cx(className, `${radioPrefixCls}-option-type-${optionType}`)}
      {...props}
    />
  );
};
